import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

import './styles/app.scss';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);